"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractRequiredValidator = exports.isRequired = exports.InternalRequiredValidator = exports.RequiredValidator = void 0;
const validator_1 = require("../base/validator");
const validation_1 = require("../../validation");
class RequiredValidator extends validator_1.BaseValidator {
    constructor(validator) {
        super();
        this.validator = validator;
    }
    get type() {
        return validation_1.validatorType(this.validator);
    }
    toSchema(traverser) {
        return {
            ...super.getJsonSchemaObject(traverser),
            ...traverser.visit(this.validator)
        };
    }
    clone(clean = false) {
        const clonedInner = validation_1.cloneValidator(this.validator, clean);
        return new RequiredValidator(clonedInner);
    }
}
exports.RequiredValidator = RequiredValidator;
class InternalRequiredValidator extends RequiredValidator {
}
exports.InternalRequiredValidator = InternalRequiredValidator;
function isRequired(validator) {
    return validator instanceof RequiredValidator;
}
exports.isRequired = isRequired;
function extractRequiredValidator(validator) {
    return validator instanceof RequiredValidator
        ? validator.validator
        : validator;
}
exports.extractRequiredValidator = extractRequiredValidator;
